export default __webpack_public_path__ + "static/media/fan_1_low.001c59e2.svg";